import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Shopify = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 28 28"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.893 5.93723C21.8765 5.8141 21.7713 5.74595 21.6844 5.73844C21.5977 5.73102 19.7622 5.59144 19.7622 5.59144C19.7622 5.59144 18.4874 4.29306 18.3474 4.14935C18.2074 4.00572 17.934 4.04941 17.8279 4.08146C17.8123 4.08618 17.5494 4.16942 17.1145 4.30748C16.6886 3.05034 15.9371 1.89508 14.6149 1.89508C14.5784 1.89508 14.5409 1.8966 14.5033 1.89879C14.1273 1.38863 13.6615 1.16699 13.2591 1.16699C10.1792 1.16699 8.70774 5.11696 8.24639 7.1242C7.0496 7.50465 6.1994 7.77512 6.0908 7.81012C5.42277 8.0251 5.40165 8.04669 5.31393 8.69246C5.24792 9.18137 3.5 23.049 3.5 23.049L17.1201 25.667L24.5 24.0291C24.5 24.0291 21.9093 6.06036 21.893 5.93723ZM16.3617 4.54633L15.2092 4.91227C15.2096 4.82894 15.21 4.74697 15.21 4.65732C15.21 3.87601 15.1043 3.24693 14.9347 2.74824C15.616 2.83596 16.0697 3.63118 16.3617 4.54633ZM14.0896 2.90317C14.279 3.39006 14.4022 4.0888 14.4022 5.03169C14.4022 5.07993 14.4018 5.12404 14.4013 5.16866C13.6518 5.40683 12.8374 5.66541 12.0212 5.92483C12.4795 4.11022 13.3386 3.23378 14.0896 2.90317ZM13.1745 2.0145C13.3075 2.0145 13.4414 2.06081 13.5696 2.1513C12.5825 2.62781 11.5245 3.82794 11.0777 6.22457L9.19623 6.82236C9.71957 4.99433 10.9623 2.0145 13.1745 2.0145Z"
        fill="#95BF46"
      />
      <path
        d="M21.7566 5.78566C21.6743 5.77845 19.9331 5.64281 19.9331 5.64281C19.9331 5.64281 18.7238 4.38109 18.5911 4.24144C18.5414 4.18948 18.4744 4.16284 18.4044 4.15137L17.4275 25.1514L24.4275 23.5599C24.4275 23.5599 21.9699 6.09849 21.9545 5.97884C21.9388 5.85918 21.839 5.79296 21.7566 5.78566Z"
        fill="#5E8E3E"
      />
      <path
        d="M15.1667 9.71079L14.2252 12.5782C14.2252 12.5782 13.4004 12.1274 12.3893 12.1274C10.9071 12.1274 10.8325 13.0799 10.8325 13.3199C10.8325 14.6295 14.1665 15.1313 14.1665 18.1989C14.1665 20.6123 12.6715 22.1663 10.6558 22.1663C8.23698 22.1663 7 20.6249 7 20.6249L7.64766 18.4338C7.64766 18.4338 8.91917 19.5516 9.99209 19.5516C10.6932 19.5516 10.9783 18.9864 10.9783 18.5734C10.9783 16.8651 8.2431 16.7889 8.2431 13.9819C8.2431 11.6193 9.89921 9.33301 13.2422 9.33301C14.5303 9.33301 15.1667 9.71079 15.1667 9.71079Z"
        fill="white"
      />
    </svg>
  )
})

export default Shopify
